import ROLES from 'config/roles';

export const MULTIPLE_COMPANIES_ROLES = [
  ROLES.QM_ADMIN,
  ROLES.CLIENT_ADMIN,
  ROLES.INSPECTOR,
  ROLES.EXTERNAL_SOURCE_OWNER,
];
